import { useIntl } from 'react-intl';
import { UncontrolledTooltip } from 'reactstrap';

import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

import { BOW_TIE_SIDE } from '../constants';
import { formatWeight, hasValue } from '../utils';

function TooltipRow({ label, value }) {
  return (
    <div className="bow-tie__tooltip-row">
      <span className="bow-tie__tooltip-label">{label}</span>
      <span className="bow-tie__tooltip-value">{value}</span>
    </div>
  );
}

function BowTieControlTooltip({ control, side, branch, target }) {
  const intl = useIntl();
  const { terms: resources, decimalSeparator, thousandsSeparator } = useAuth();
  const isPreventive = side === BOW_TIE_SIDE.PREVENTIVO;
  const effectiveness = control?.ultimaEfetividade;
  const hasWeight = hasValue(control?.peso);
  const controlType = capitalizeFirstLetter(
    intl.formatMessage(
      { id: isPreventive ? 'controlePreventivo' : 'controleCorretivo' },
      { pontodecontrole: resources?.pontodecontrole }
    )
  );
  const branchType = capitalizeFirstLetter(
    isPreventive
      ? resources?.pontosproblematicos || ''
      : resources?.consequencias || ''
  );
  const responsibleLabel = capitalizeFirstLetter(
    intl.formatMessage(
      { id: 'responsavel' },
      { responsavel: resources?.responsavel }
    )
  );

  return (
    <UncontrolledTooltip
      placement="auto"
      target={target}
      delay={{ show: 150, hide: 0 }}
      popperClassName="bow-tie__tooltip-wrapper"
      innerClassName="bow-tie__tooltip"
    >
      <div className="bow-tie__tooltip-content">
        <div className="bow-tie__tooltip-title">{control.nome}</div>
        <div className={`bow-tie__tooltip-type bow-tie__tooltip-type--${side}`}>
          {controlType}
        </div>
        <div className="bow-tie__tooltip-details">
          <TooltipRow label={branchType} value={branch.nome} />
          <TooltipRow label={responsibleLabel} value={control.responsavel} />
          {hasWeight && (
            <TooltipRow
              label={capitalizeFirstLetter(intl.formatMessage({ id: 'peso' }))}
              value={`${formatWeight(
                control.peso,
                decimalSeparator,
                thousandsSeparator
              )}%`}
            />
          )}
          {hasValue(effectiveness) && (
            <TooltipRow
              label={capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.efetividade' })
              )}
              value={effectiveness}
            />
          )}
        </div>
      </div>
    </UncontrolledTooltip>
  );
}

export default BowTieControlTooltip;
